import { TagIcon } from "@primer/octicons-react";
import "../IdentityLink/IdentityLink.css";
import "./PropertyIdentity.css";

export function propertyHref(propertyId) {
  return `#/properties/${encodeURIComponent(propertyId)}`;
}

export function PropertyIdentity({ href, property }) {
  const Target = href ? "a" : "span";
  return <Target className="identity-link property-identity" href={href}><TagIcon aria-hidden="true" /><strong className="identity-link-label">{property.name}</strong></Target>;
}
